import { BellIcon } from 'lucide-react'
import type { AcaoUi } from './acao-ui'
import { DESTINATARIOS, type Destinatario } from '@acme/core'
import { FormField, FormFieldAutocomplete } from 'global/components/Form'
import IconeAjuda from 'global/components/IconeAjuda'
import Grid from 'global/components/ui/Grid'

const ROTULO_DESTINATARIO: Record<Destinatario, string> = {
    funcionario: 'Funcionário',
    gestores: 'Gestores',
    administradores: 'Administradores',
}

/** Começa vazia para o Zod acusar os campos obrigatórios. */
export const NOTIFICACAO_INICIAL = {
    destinatarios: [],
    titulo: '',
    mensagem: '',
}

/** Campos comuns às notificações no site e por e-mail. */
export function ParametrosNotificacao({
    rotuloTitulo,
}: {
    rotuloTitulo: string
}) {
    return (
        <>
            <Grid item xs={12}>
                <FormFieldAutocomplete
                    name="parametros.destinatarios"
                    label="Destinatários"
                    multiple
                    required
                    options={DESTINATARIOS}
                    getOptionLabel={(destinatario: Destinatario) =>
                        ROTULO_DESTINATARIO[destinatario]
                    }
                    isOptionEqualToValue={(opcao, valor) => opcao === valor}
                    endAdornment={
                        <IconeAjuda>
                            <b>Funcionário:</b> o próprio funcionário que
                            disparou a rotina.
                            <br />
                            <br />
                            <b>Gestores:</b> supervisores com permissão para o
                            funcionário.
                            <br />
                            <br />
                            <b>Administradores:</b> todos os usuários
                            administradores do cliente.
                        </IconeAjuda>
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="parametros.titulo"
                    label={rotuloTitulo}
                    required
                />
            </Grid>
            <Grid item xs={12}>
                <FormField
                    name="parametros.mensagem"
                    label="Mensagem"
                    helperText="Use {funcionario}, {data} e {motivo}"
                    multiline
                    required
                    endAdornment={
                        <IconeAjuda>
                            Valem no título e na mensagem e são trocados ao
                            enviar, para cada funcionário:
                            <br />
                            <br />
                            <b>{'{funcionario}'}</b>: nome do funcionário.
                            <br />
                            <b>{'{data}'}</b>: dia avaliado, em dd/mm/aaaa.
                            <br />
                            <b>{'{motivo}'}</b>: o que disparou a rotina, como
                            em "Falta integral em 25/10 (08:00)".
                        </IconeAjuda>
                    }
                />
            </Grid>
        </>
    )
}

export const notificarSite: AcaoUi = {
    icone: BellIcon,
    parametrosIniciais: NOTIFICACAO_INICIAL,
    Parametros: () => <ParametrosNotificacao rotuloTitulo="Título" />,
}
